<template>
  <div class="container-fluid full-width-page-wrapper">
    <div class="row">
      <div class="col my-auto">
        <h3 class="page-title">My evaluations</h3>
      </div>
    </div>

    <tabs v-model="currentTab" :tabItems="tabs">
      <template slot="tab-content">
        <ReviewsTable :reviews="filteredReviews"/>

        <div class="d-flex justify-content-end">
          <!-- Close Review Phase -->
          <div class="text-right mt-2"
               v-if="currentAward?.can.closeReviewPhase || currentAward?.isReviewPhaseClosed">
            <button
              @click="handleCloseReviewPhase"
              :disabled="currentAward.isReviewPhaseClosed"
              type="button"
              class="btn btn-primary"
            >
              <span v-if="currentAward.isReviewPhaseClosed === true">Review Phase Closed</span>
              <span v-else>Close Review Phase</span>
            </button>
          </div>

          <!-- Close Selection Phase -->
          <div class="text-right mt-2 ml-2"
               v-if="currentAward?.can.closeSelectionPhase || currentAward?.isSelectionPhaseClosed">
            <button
              @click="handleCloseSelectionPhase"
              :disabled="currentAward.isSelectionPhaseClosed"
              type="button"
              class="btn btn-primary"
            >
              <span v-if="currentAward.isSelectionPhaseClosed === true">Selection Phase Closed</span>
              <span v-else>Close Selection Phase</span>
            </button>
          </div>
        </div>
      </template>
    </tabs>

  </div>
</template>

<script>
import ReviewsTable from '@/views/areas/awards/reviews/partials/ReviewsTable.vue';
import Tabs from '@/views/components/Tabs.vue';
import Awards from '@/services/Api/Awards/Awards';
import Reviews from '@/services/Api/Awards/Reviews';
import { IfacEventBus } from '@ifac/ui';

export default {
  name: 'AwardsReviews',
  components: { Tabs, ReviewsTable },
  data() {
    return {
      reviews: [],
      currentTab: null,
    };
  },
  created() {
    this.fetchReviews();

    IfacEventBus.$on('updateConflict', (review) => {
      const index = this.reviews.findIndex((r) => r.id === review.id);
      if (index >= 0) {
        this.$set(this.reviews, index, review);
      }
    });
  },
  beforeDestroy() {
    IfacEventBus.$off('updateConflict');
  },
  methods: {
    fetchReviews() {
      const params = {
        relations: [
          'affiliate',
          'nomination.award',
          'nomination.reports',
        ],
      };

      this.loading = true;

      Reviews.all(params).then((response) => {
        this.reviews = response.data.data;

        if (this.section !== this.tabs[0].id) {
          this.$router.push({
            name: 'Reviews',
            query: { section: this.tabs[0].id },
          });
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleCloseReviewPhase() {
      Awards.closeReviewPhase(this.currentAward.id).then(() => {
        this.fetchReviews();
      });
    },
    handleCloseSelectionPhase() {
      Awards.closeSelectionPhase(this.currentAward.id).then(() => {
        this.fetchReviews();
      });
    },
  },
  computed: {
    section() {
      return this.$route.query.section;
    },
    currentAward() {
        return this.awards.find((a) => a.id === this.section);
    },
    awards() {
      return this.reviews.reduce((acc, item) => {
        const { id } = item.nomination.award;
        const exists = acc.some((entry) => entry.id === id);
        if (!exists) {
          acc.push(item.nomination.award);
        }
        return acc;
      }, []);
    },
    tabs() {
      return this.awards.map((award) => ({
              id: award.id,
              name: award.id,
              label: award.name,
          }));
    },
    filteredReviews() {
      return this.reviews.filter((r) => r.nomination.award.id === this.section);
    },
  },
};
</script>

<style scoped lang='scss'>
@import '@/assets/styles/base/_variables.scss';
@import '@/assets/styles/base/_mixins.scss';
</style>
